import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

/* eslint-disable react/require-default-props */
import React from 'react';
import { node, string } from 'prop-types';
import propTypes from '@styled-system/prop-types';
import { Svg } from './SvgIcon.styles';

function SvgIcon(_ref) {
  let {
    children,
    titleAccess
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "titleAccess"]);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 24,
    height: 24
  }, props), titleAccess && /*#__PURE__*/React.createElement("title", null, titleAccess), children);
}

process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = Object.assign({
  children: node,
  className: string,
  titleAccess: string
}, propTypes.color, propTypes.layout, propTypes.space) : void 0;
export default SvgIcon;